import z from 'zod'
import { RubricType } from '../../types'
import {
  firestoreWriteTimestamp,
  nullSafeBoolean,
  nullSafeOptionalFirestoreTimestamp,
} from '../shared/schema'

/**
 * A single saved score-mapping default: for a given rubric type, the mapping of
 * each rubric score to the percentage it contributes to the AI Assessment.
 * `scoreMapping` mirrors the per-assignment AssignmentRubric `scoreMapping` (keys
 * are canonical non-negative integer strings, values are percentages 0–100).
 */
export const scoreMappingDefaultSchema = z.object({
  rubricType: z.nativeEnum(RubricType),
  scoreMapping: z.record(z.string(), z.number().min(0).max(100)),
})

export const schema = z.object({
  defaults: z.array(scoreMappingDefaultSchema).default([]),
  // When true, new assignments default the "grade this assignment" toggle to on.
  assignFinalGrade: nullSafeBoolean(false),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
})

export const writeSchema = schema.extend({
  updatedAt: firestoreWriteTimestamp,
})

export const empty = Object.freeze(schema.parse({ defaults: [] }))

export type FirestoreScoreMappingDefault = z.infer<
  typeof scoreMappingDefaultSchema
>
export type FirestoreUserProfileScoreMappingDefaults = z.infer<typeof schema>
